/**
 * Created by JasonChou on 17/1/16.
 */
import typeUtils from'../utils/typeUtils'

global.cache = {
  getStr(key){
    return localStorage.getItem(key)
  },

  getJSONObj(key){
    return JSON.parse(this.getStr(key))
  },

  set(key, value){

    if (typeUtils.isObject(value) || Array.isArray(value)) {
      value = JSON.stringify(value);
    }

    localStorage.setItem(key, value)
  }
}



// WEBPACK FOOTER //
// ./src/libs/cache.js